import { render } from "./SliderPanel.vue?vue&type=template&id=b0e950c2&scoped=true"
import script from "./SliderPanel.vue?vue&type=script&lang=js"
export * from "./SliderPanel.vue?vue&type=script&lang=js"

import "./SliderPanel.vue?vue&type=style&index=0&id=b0e950c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b0e950c2"

export default script